import gql from 'graphql-tag';
import { UserCoreAttributes } from './users';

export const InternalNoteCoreAttributes = `
id
content
createdAt
updatedAt
thingId
thingType
user {
  ${UserCoreAttributes}
}
`;

export const CreateInternalNoteMutation = gql`
  mutation CreateInternalNoteMutation($content: String!, $thingId: String!, $thingType: String!) {
    createInternalNote(content: $content, thingId: $thingId, thingType: $thingType) {
      internalNote {
        ${InternalNoteCoreAttributes}
      }
    }
  }
`

export const UpdateInternalNoteMutation = gql`
  mutation UpdateInternalNoteMutation($id:String!, $content: String!) {
    updateInternalNote(id:$id, content: $content) {
      internalNote {
        ${InternalNoteCoreAttributes}
      }
    }
  }
`

export const DestroyInternalNoteMutation = gql`
  mutation DestroyInternalNoteMutation($id:String!) {
    destroyInternalNote(id: $id) {
      status
    }
  }
`